// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------

///////////////
// freespins //
///////////////

/* this module manages both freespins modes it inherits from spin functions*/

freespins = (function () {
  var _inFreeSpins = false;
  var _endFreespinsTask;
  var _startFreeSpinsTask;

  var messageBox = undefined;

  var _bonusParticles;

  var _initialDroppingFS = 0;

  var _multiplierDisplay = undefined;

  var _freeSpinsMeter;

  var _gigabloxFactory = undefined;

  function initialise() {
    _freeSpinsMeter = resourceManager.get('freeSpinsMeter');
    _multiplierDisplay = resourceManager.get('multiDisplay:multiplierDisplay');
    _gigabloxFactory = resourceManager.get('slotContainer:GigabloxFactory');

    messageBox = resourceManager.get('slotContainer:messageBar');
  }

  /////////////////
  // button code //
  /////////////////

  function canEnableSpin() {
    return freespins.stateMachine.ActiveStateName === 'READY_TO_START';
  }

  function canShowSpin() {
    return freespins.stateMachine.ActiveStateName === 'READY_TO_START';
  }

  function canEnableSkip() {
    return freespins.stateMachine.ActiveStateName === 'PAYWINS';
  }

  function canShowSkip() {
    return freespins.stateMachine.ActiveStateName === 'PAYWINS';
  }

  ////////////////
  ////////////////

  // this just flips the layout between freeSpins and normal
  function freespinsMode(bool) {
    _inFreeSpins = bool;
  }

  function onFreespinsStart(task) {
    _startFreeSpinsTask = task;
    _startFreeSpinsTask.join();

    freespins.stateMachine.switchState('PLAY_SCATTER_ANIMS');
  }

  function onFreespinsStartDead(task) {
    // if(autoplayManager.stopOnBonus){
    // 	gdk.autoplay.reset();
    // }

    _winnings = 0;

    // To get around sound being muted on Playzido when recovering in freespins, allow the player to enable sound again by moving mute button

    musicManager.onFreespinsStart();

    freespinsMode(true);
    startSpins();
  }

  function startSpins() {
    //musicManager.resetfreeSpinsLevel();

    startGame();
    gdk.getNextGameOutcome(function () {});
  }

  function startGame() {
    gameController.resetWinnings();
    gameData.numPops = 0;

    gameController.firstLongSpinReelId = undefined;
    gameController.lastLongSpinReelId = undefined;

    freespins.spinTask = undefined;
    // symbolGlowManager.cancelAllGlows();

    // for (var i = 0; i < gameData.reels.length; i++) {
    //   gameData.reels[i].setSpinParameters({
    //     decelerationDistance: 1,
    //   });
    //   gameData.reels[i].setSpinParameters({
    //     landOffset: 0.25,
    //   });
    //   gameData.reels[i].setSpinParameters({
    //     spinSpeed: 22,
    //   });
    // }

    _freeSpinsMeter.useSpin();

    //		musicManager.resetfreeSpinsLevel();

    // reset the stop distances
    gameController.cleanUpAboveSymbolsBeforeSpin();
    // game.stopDistances = JSON.parse(JSON.stringify(game.baseStopDistances));
    _gigabloxFactory.infiniteSpin();

    //freespins.stateMachine.switchState("CLEAR_REELS");

    freespins.stateMachine.switchState('REELS_SPINNING');
  }

  // function onFreespinsAwardedEnd() {
  //   gdk.getNextGameOutcome(function () {});
  // }

  // function onMultiplierEvent(task) {
  //   // If we are at the top of the multiplier bar, ignore task
  //   if (task.data.nextMultiplier === -1 && task.data.currentStep > 1) {
  //     return;
  //   }

  //   freespins.MultiplierTask = task;
  //   //	task.join();
  // }

  function setupFsScene(numFs) {
    //resourceManager.get("slotContainer:reelContainer").visible = false;

    //	let reels = resourceManager.get("slotContainer:reelContainer");
    //	timerManager.addTimer( 200, function( progress ) { reels.alpha = 1.0 - progress;}, function() { reels.alpha = 0;} );

    musicManager.onFreespinsIntro();
  }

  function onStepUpComplete() {
    freespins.MultiplierTask.leave();
    return;

    if (freespins.MultiplierTask.data.currentStep === 1 && freespins.MultiplierTask.data.currentMultiplier > 1) {
      // Increase multiplier
      var newNumSteps =
        freespins.MultiplierTask.data.nextMultiplier !== -1 ? freespins.MultiplierTask.data.totalSteps : 0;
      onIncreaseMultiplierComplete();
      //_rightTotem.increaseMultiplier(freespins.MultiplierTask.data.currentMultiplier, freespins.MultiplierTask.data.nextMultiplier, newNumSteps, onIncreaseMultiplierComplete);
    } else {
      freespins.MultiplierTask.leave();
    }
  }

  function onIncreaseMultiplierComplete() {
    freespins.MultiplierTask.leave();
    return;

    if (freespins.MultiplierTask.data.nextMultiplier !== -1) {
      //_rightTotem.stepUp( function() { freespins.MultiplierTask.leave(); } );
    } else {
      freespins.MultiplierTask.leave();
    }
  }

  function onFreespinsDataEvent(task) {
    _spinsRemaining = task.num;

    // always delay next spin - as it will always happen after a losing cascade
    timerManager.addTimer(750, undefined, function () {
      getNextSpinOutcome();
    });
  }

  ///////////////////////////////
  function getNextSpinOutcome() {
    startGame();
    gdk.getNextGameOutcome(function () {});
  }

  // function onGambleResultEvent(task) {
  //   let temp = task;
  //   temp.join();
  //   _gambleSpin.spinToResult(task.data.won, function () {
  //     temp.leave();
  //     temp = undefined;
  //   });
  // }

  // function onGambleResultEventDead(task) {
  //   // we've lost so restore reels container display and stop music
  //   // may need a delay to process visually
  //   if (!task.won) {
  //     _bonusAnimsPlayed = false;

  //     soundManager.stop('gambleLoop');

  //     musicManager.onFreespinsLostGambleEnd();
  //     //let reels = resourceManager.get("slotContainer:reelContainer");
  //     //reels.alpha = 1.0;

  //     _freeSpinsIntroOutro = resourceManager.get('freeSpinsIntroOutroContainer:FreeSpinsIntroOutro');
  //     _freeSpinsIntroOutro.showConsolation();
  //   }
  // }

  function onFreespinsEndEvent(task) {
    _endFreespinsTask = task;
    _endFreespinsTask.join();
    excitementManager.clear();
    messageBox.setMessage('');

    //_freeSpinsMeter.hideMeter();
    resourceManager.getContainer('freeSpinsContainer').visible = false;

    _bonusAnimsPlayed = false;

    // delay before entering free spins outro/big win
    timerManager.addTimer(500, undefined, function () {
      showSummary();
    });
  }

  function showSummary() {
    let freeSpinsWin = _endFreespinsTask.data.fsWinnings;

    doFreeSpinsOutroDialog(freeSpinsWin);
  }

  function doFreeSpinsOutroDialog(freeSpinsWin) {
    // Show outro

    const freeSpinsOutro = resourceManager.get('freeSpinsOutroContainer:FreeSpinsOutro');
    freeSpinsOutro.show(freeSpinsWin, () => {
      doBigWinCheck();
    });
  }

  function doBigWinCheck() {
    let totalWinnings = _endFreespinsTask.data.totalWinnings;

    const bigWin = resourceManager.get('bigWin:BigWin');
    let isBigWin = bigWin.willTriggerBigWin(
      totalWinnings, //
      gameController.globalHelperGetBaseStake()
    );

    if (isBigWin) {
      bigWin.start({
        winAmount: totalWinnings,
        cbWhenFinished: () => {
          endFreespins();
        },
        whereFrom: 'freespinsEnd',
      });
    } else {
      endFreespins();
    }
  }

  function endFreespins() {
    musicManager.onFreespinsEnd();

    _multiplierDisplay.closeDoor(true, false);
    resourceManager.getContainer('fsBackgroundContainer').visible = false;

    freespinsMode(false);
    gameData.inputOverlord.setState('enabled');
    slotMachine.selectReelMode('standard');

    _gigabloxFactory.setCurrentMode('default');

    freespins.stateMachine.switchState('READY_TO_START');
    _endFreespinsTask.leave();
  }

  ////////////////////////////////////////////
  // define freespins Object to be returned //
  ////////////////////////////////////////////

  freespins = Object.create(spinFunctions);
  Object.defineProperties(freespins, {
    initialise: {
      value: initialise,
    },
    freespinsMode: {
      value: freespinsMode,
    },
    inFreespins: {
      get: function () {
        return _inFreeSpins;
      },
    },
    onFreespinsStart: {
      value: onFreespinsStart,
    },
    onFreespinsStartDead: {
      value: onFreespinsStartDead,
    },
    onFreespinsDataEvent: {
      value: onFreespinsDataEvent,
    },
    onFreespinsEndEvent: {
      value: onFreespinsEndEvent,
    },
    canEnableSpin: {
      value: canEnableSpin,
    },
    canShowSkip: {
      value: canShowSkip,
    },
    canEnableSkip: {
      value: canEnableSkip,
    },
    canShowSpin: {
      value: canShowSpin,
    },
    startGame: {
      value: startGame,
    },
  });

  ///////////////////
  // State Machine //
  ///////////////////

  StateMachine.Create(freespins);

  //////////////////////////////////////////////////////
  freespins.stateMachine.addState('WAITING_FOR_SERVER', function () {});

  //////////////////////////////////////////////////////
  freespins.stateMachine.addState('READY_TO_START', function () {});

  freespins.stateMachine.addState('PLAY_SCATTER_ANIMS', function () {
    if (freespins.phase.timed(250)) {
    }

    if (freespins.phase.once()) {
      // we need to play the scatter win anims on the reels
      gdk.cancelAutoplay();
      soundManager.play('scatterIntro');
      gameController.playScatterWinAnimations();
    }

    if (freespins.phase.hold()) {
      if (!gameController.anyScatterWinAnimsStillPlaying()) {
        gameController.hideScatterWinAnimsStillPlaying();
        freespins.phase.step();
      }
    }

    if (freespins.phase.timed(500)) {
    }

    if (freespins.phase.once()) {
      // this won't be playing if we've gone in with max free spins - so start here
      musicManager.onFreespinsIntro();

      _freeSpinsMeter.resetMeter();
      _freeSpinsMeter.addSpins(_startFreeSpinsTask.data.freeSpinsAwarded);

      gameData.inputOverlord.setState('freespinsEnabled');

      _multiplierDisplay.closeDoor(true, true);
      resourceManager.getContainer('freeSpinsContainer').visible = true;
      resourceManager.getContainer('fsBackgroundContainer').visible = true;

      const freeSpinsIntro = resourceManager.get('freeSpinsIntroContainer:FreeSpinsIntro');
      freeSpinsIntro.show(_startFreeSpinsTask.data.freeSpinsAwarded, () => {
        freespins.stateMachine.switchState('WAITING_FOR_SERVER');
        _gigabloxFactory.setCurrentMode('freeSpins');
        _startFreeSpinsTask.leave();
        _startFreeSpinsTask = undefined;
      });
    }
  });

  //////////////////////////////////////////////////////
  freespins.initialDropComplete = function (reelID) {
    --_initialDroppingFS;
  };

  freespins.areFreeSpinsActive = function () {
    return freespins._inFreeSpins;
  };

  //////////////////////////////////////////////////////
  // freespins.stateMachine.addState('CLEAR_REELS', function () {
  //   // when reels have cleared we can drop in new positions
  //   // clear reels has a callback to reduce reelsDropping count

  //   if (freespins.phase.enter()) {
  //   }

  //   // ensure we have result data before proceeding - don't clear reels until this is set
  //   if (freespins.phase.hold()) {
  //     if (freespins.spinTask !== undefined) {
  //       freespins.phase.step();
  //     }
  //   }

  //   if (freespins.phase.once()) {
  //     slotMachine.clearReels();

  //     _initialDroppingFS = gameData.reels.length;
  //     gameController.resetSymbolCallbackFired();
  //   }

  //   if (freespins.phase.hold()) {
  //     if (_initialDroppingFS === 0) {
  //       let _positions = freespins.spinTask.data.resultPanel.reelList.map(function (reel, index) {
  //         return reel.symbols.map(function (curr) {
  //           return curr.value;
  //         });
  //       });

  //       // we need to have a random symbol as the first below which we can drop
  //       // off the symbol grid when new symbols all cascade in
  //       // NOTE:  Freespins can't retrigger so make sure no feature symbols are selected
  //       // Also wild symbols shouldn't be shown so limit to first 8
  //       let randomBelow = [];
  //       for (var i = 0; i < gameData.reels.length; i++) {
  //         randomBelow[i] = getRandom(8);
  //       }

  //       let _symbolsAbove = [[0], [0], [0], [0], [0]];
  //       let _symbolsBelow = [[randomBelow[0]], [randomBelow[1]], [randomBelow[2]], [randomBelow[3]], [randomBelow[4]]];

  //       // calculate whether we display landing symbols - this should be empty for free spins
  //       gameController.calcLandingAnims();

  //       slotMachine.dropInitialSymbols(_symbolsAbove, _positions, _symbolsBelow);
  //       freespins.phase.step();
  //     }
  //   }

  //   if (freespins.phase.once()) {
  //     freespins.stateMachine.switchState('REELS_SPINNING');
  //   }
  // });

  //////////////////////////////////////////////////////
  freespins.stateMachine.addState('REELS_SPINNING', function () {
    if (freespins.phase.enter()) {
      gameController.reelsSpinning = true;
    }

    if (freespins.phase.hold()) {
      if (gameController.spinTask !== undefined) {
        gameController._receivedResponse = true; // this allows slam stop

        gameController.blockDistributionData = {
          blockDistribution: gameController.spinTask.data.blockDistribution,
          board: gameController.spinTask.data.lastRespin.payBoard,
        };

        freespins.phase.step();
      }
    }

    // wait for all reels to have landed before checking whether landing anims are finished
    if (freespins.phase.hold()) {
      if (gameController.reelsSpinning === false) {
        freespins.phase.step();
      }
    }

    if (freespins.phase.once()) {
      freespins.stateMachine.switchState('WAITING_FOR_SERVER');
    }

    if (freespins.phase.exit()) {
      if (freespins.spinTask) {
        gameController._receivedResponse = false;
        freespins.spinTask.leave();
      }
    }
  });

  //////////////////////////////////////////////////////
  freespins.stateMachine.addState('PAYWINS', function () {});

  //////////////////////////////////////////////////////
  freespins.stateMachine.addState('PAY_TO_WINNINGS', function () {
    if (freespins.phase.enter()) {
      gameData.winningsMeter.countUp(freespins.winsTask.data.totalLineWinnings, 1000);
      messageBox.hide();
    }
    if (freespins.phase.hold()) {
      if (!gameData.winningsMeter.Props.isCounting) {
        freespins.winsTask.leave();
      }
    }
  });

  function update(delta) {
    _delta = delta;
    this.stateMachine.update();
  }

  // messageBus.subscribe('tiki_runner:MultiplierEvent', onMultiplierEvent);
  messageBus.subscribe('tiki_runner:FreeSpinsStartEvent', onFreespinsStart);
  messageBus.subscribe('tiki_runner:FreeSpinsStartEventDead', onFreespinsStartDead);
  messageBus.subscribe('tiki_runner:FreeSpinsDataEventDead', onFreespinsDataEvent);
  messageBus.subscribe('tiki_runner:FreeSpinsEndEvent', onFreespinsEndEvent);

  Reflex.addToUpdate(update.bind(freespins));

  return freespins;
})();
